/**
 * The collections a marketplace Q&A channel can be a row of. Mirrors
 * `MARKETPLACE_ACCOUNT_COLLECTIONS` in qpien-ai, and api-v2's `MIGRATION_ID_REF_COLLECTIONS` must
 * allow all eight — otherwise the panel's count and the runner's selection disagree.
 */
export const MARKETPLACE_ACCOUNT_COLLECTIONS: ReadonlyArray<string> = [
  "TrendyolAccounts",
  "HepsiburadaAccounts",
  "N11Accounts",
  "AmazonAccounts",
  "EbayAccounts",
  "KauflandAccounts",
  "PazaramaAccounts",
  "WalmartAccounts"
]
